const searchIndex = [
  {
    id: "home",
    type: "public",
    category: "Pogforts",
    title: "Pogforts Home",
    path: "/",
    keywords: [
      "pogforts",
      "home",
      "discord",
      "server",
      "murder mystery magic",
      "mmm",
      "magical sorting bat",
      "community",
    ],
    content:
      "Welcome to Pogforts, the home of Murder Mystery Magic, the Magical Sorting Bat, house competition, Discord community play, blog posts, news, and public information about the Pogforts world.",
  },
  {
    id: "house-cup",
    type: "public",
    category: "Pogforts",
    title: "House Cup",
    path: "/house-cup",
    keywords: [
      "house cup",
      "houses",
      "points",
      "merits",
      "strikes",
      "rayvern-claw",
      "huff-n-pufff",
      "slithery-inn",
      "gibbons-door",
    ],
    content:
      "House Cup tracks Pogforts house points, merits, strikes, totals, and competition between Rayvern-Claw, Huff-N-Pufff, Slithery-Inn, and Gibbons-Door.",
  },
  {
    id: "leaderboards",
    type: "public",
    category: "Pogforts",
    title: "Leaderboards",
    path: "/leaderboards",
    keywords: ["leaderboards", "rankings", "xp", "users", "top", "stats", "pogs"],
    content:
      "Leaderboards displays Pogforts ranking information, top players, XP, activity, and public community performance statistics.",
  },
  {
    id: "blog",
    type: "blog",
    category: "Blog",
    title: "Pogforts Blog",
    path: "/blog",
    keywords: ["blog", "posts", "articles", "updates", "authors", "pogforts blog"],
    content:
      "Pogforts Blog contains public articles, permanent posts, updates, announcements, community writing, and official Pogforts content.",
  },
  {
    id: "news",
    type: "news",
    category: "News",
    title: "Pogforts News",
    path: "/news",
    keywords: ["news", "updates", "announcements", "latest", "public news"],
    content:
      "Pogforts News is the public news area for updates, announcements, and latest information.",
  },
  {
    id: "mmm",
    type: "public",
    category: "Game",
    title: "Murder Mystery Magic",
    path: "/mmm",
    keywords: [
      "mmm",
      "murder mystery magic",
      "game",
      "discord game",
      "guess who",
      "league of legends",
      "roles",
    ],
    content:
      "Murder Mystery Magic is the Pogforts Discord server game with deduction, magic, roles, combat, house identity, social gameplay, and server progression.",
  },
  {
    id: "items",
    type: "public",
    category: "Game",
    title: "Items",
    path: "/items",
    keywords: ["items", "weaponry", "protection", "hardware", "gadget", "gear", "inventory"],
    content:
      "Items explains Pogforts game inventory, weaponry, protection, hardware, gadgets, equipment, and game-use resources.",
  },
  {
    id: "ultimates",
    type: "public",
    category: "Game",
    title: "Ultimates",
    path: "/ultimates",
    keywords: ["ultimates", "ultimate", "abilities", "powers", "cooldowns", "game mechanics"],
    content:
      "Ultimates explains powerful Pogforts game abilities, ultimate mechanics, player powers, special effects, and progression rewards.",
  },
  {
    id: "msb",
    type: "public",
    category: "Bot",
    title: "Magical Sorting Bat",
    path: "/msb",
    keywords: ["msb", "magical sorting bat", "discord bot", "bot", "sorting", "commands", "automation"],
    content:
      "Magical Sorting Bat is the Pogforts Discord bot powering server game systems, house sorting, public commands, community automation, and Murder Mystery Magic features.",
  },
  {
    id: "commands",
    type: "public",
    category: "Bot",
    title: "Commands",
    path: "/commands",
    keywords: ["commands", "slash commands", "discord commands", "create", "diceroll", "mod", "bot help"],
    content:
      "Commands lists public Magical Sorting Bat commands, Discord slash commands, context menus, gameplay actions, and bot usage information.",
  },
  {
    id: "upvote",
    type: "public",
    category: "Bot",
    title: "Upvote",
    path: "/upvote",
    keywords: ["upvote", "vote", "bot list", "support", "magical sorting bat"],
    content:
      "Upvote provides public information for supporting and voting for the Magical Sorting Bat bot.",
  },
  {
    id: "terms-of-services",
    type: "legal",
    category: "Legal",
    title: "Terms of Services",
    path: "/terms-of-services",
    keywords: ["terms", "terms of services", "rules", "service", "legal", "conditions"],
    content:
      "Terms of Services explains the legal rules, responsibilities, acceptable use, limitations, and public service conditions for Pogforts.",
  },
  {
    id: "privacy-policy",
    type: "legal",
    category: "Legal",
    title: "Privacy Policy",
    path: "/privacy-policy",
    keywords: ["privacy", "policy", "data", "cookies", "personal information", "legal"],
    content:
      "Privacy Policy explains public information about data handling, privacy, cookies, personal information, analytics, and user protections for Pogforts.",
  },
  {
    id: "equality-policy",
    type: "legal",
    category: "Legal",
    title: "Equality Policy",
    path: "/equality-policy",
    keywords: ["equality", "policy", "inclusion", "fairness", "respect", "legal"],
    content:
      "Equality Policy explains Pogforts commitments to fairness, inclusion, respectful community conduct, equal access, and anti-discrimination principles.",
  },
  {
    id: "missayu",
    type: "special",
    category: "Special Public Page",
    title: "Miss Ayu",
    path: "/missayu",
    keywords: [
      "miss ayu",
      "instructor",
      "tuition",
      "teacher",
      "indonesia",
      "english",
      "maths",
      "lessons",
      "remote",
      "onsite",
      "taster",
    ],
    content:
      "Miss Ayu is a special public page for an instructor offering Maths and English lessons, Indonesian and UK themed presentation, onsite and remote learning options, taster sessions, testimonials, archive content, and contact form information.",
  },
];

export const excludedSearchPathPrefixes = [
  "/analytics",
  "/admin",
  "/online",
  "/tools",
  "/gamble",
  "/black-market",
  "/auth",
];

export function isPublicSearchPath(path) {
  const safePath = String(path || "").trim().toLowerCase();

  if (!safePath || !safePath.startsWith("/")) {
    return false;
  }

  return !excludedSearchPathPrefixes.some(
    (prefix) => safePath === prefix || safePath.startsWith(`${prefix}/`)
  );
}

export default searchIndex;
